import MarkdownIt from 'markdown-it';
import insert from 'markdown-it-ins';
import mila from 'markdown-it-link-attributes';
import sanitizeHtml from 'sanitize-html';

const markdownParser = new MarkdownIt({
    breaks: true,
    linkify: true,
    typographer: true,
    html: true,
})
    .use(insert)
    .use(mila, {
        attrs: {
            target: '_blank',
            rel: 'noreferrer',
        },
    });

export const markdownSanitize = (markdown: string): string => {
    // handles TH5-2110: https://strangebee.atlassian.net/browse/TH5-2110
    // Remove email in < > character when text has form #<...@...>
    const emailInTagRegex = /<([^\s<>]+@[^\s<>]+)>/g;

    const safeMarkdown = markdown.replace(emailInTagRegex, '$1');

    // 1. Sanitize unauthorized tags and attributes in markdown
    // 2. Transform markdown to HTML
    return markdownParser.render(sanitizeHtml(safeMarkdown, { allowedTags: ['br'] }));
};
